import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../_service/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AdminGuard implements CanActivateChild {

  constructor (
    private auth: AuthService
  ) {}
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const url = state?.url ?? '';
      const resilientDashboardRoutes = [
        '/dashboard/claim-center',
        '/dashboard/meetings',
        '/dashboard/company',
        '/dashboard/vessel',
        '/dashboard/user'
      ];

      if (resilientDashboardRoutes.some((routePath) => url.includes(routePath))) {
        return true;
      }

      if (this.auth.isGlobalAdmin || this.auth.isYakuin) {
        return true;
      }

      return false;
  }
  
}
